import { useState } from "react";
import Wrapper, {
    EFMEWrapperProps,
} from "../../../../components/shared/Wrapper";
import AttorneySelect from "../../../../components/shared/AttorneySelect";
import * as APIModels from "../../../../models";
import { JobsService } from "../../../../services/RecordsService";
import { GuidDetailedResponse } from "../../../../models/swagger/generated-client-service";

const caseExportExecute: EFMEWrapperProps = {
    breadcrumbTitle: "Execute",
    breadcrumbSuper: "Case Export",
    pageTitle: "Execute Case Export",
};

export default function CaseExportExecute(): JSX.Element {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setFirmId] = useState<string>();
    const [attorneyId, setAttorneyId] = useState<string>(APIModels.EmptyGuid);
    const [attorneyName, setAttorneyName] = useState<string>("Joe Shmoe");
    const [loading, setLoading] = useState<boolean>();
    const [ran, setRan] = useState<boolean>();
    const [detailedResponse, setDetailedResponse] =
        useState<GuidDetailedResponse>();

    const RunCaseExport = (id: string): void => {
        setLoading(true);
        setRan(true);

        const wait = JobsService.execute({ attorneyId: id });

        wait.then((res) => {
            setLoading(false);
            setDetailedResponse(res);
        });
    };

    const CaseExportExecuteButton = () => {
        if (loading) {
            return <SpinningButton />;
        }

        if (attorneyId === APIModels.EmptyGuid) {
            return <DisabledButton />;
        }

        return (
            <button
                className="btn btn-primary"
                type="button"
                onClick={() => {
                    RunCaseExport(attorneyId);
                }}
            >
                <i className="ri-terminal-box-fill mr-2"></i>
                Execute Case Export
            </button>
        );
    };

    return (
        <Wrapper {...caseExportExecute}>
            <div className="row mb-4">
                <div className="col-md-12">
                    <AttorneySelect
                        onFirmSelected={(id) => {
                            setFirmId(id);
                            setRan(false);
                        }}
                        onAttorneySelected={(id, val) => {
                            setAttorneyId(id);
                            setAttorneyName(val);
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <CaseExportExecuteButton />
                </div>
            </div>
            <CaseExportExecuteResponse
                attorneyName={attorneyName}
                response={
                    detailedResponse ??
                    ({
                        data: "",
                        successful: false,
                        errorMessage: "Error during Ui State Managment",
                    } as GuidDetailedResponse)
                }
                ran={ran ?? false}
                loading={loading ?? false}
            />
        </Wrapper>
    );
}

const SpinningButton = () => {
    return (
        <button className="btn btn-primary" type="button" disabled={true}>
            <span
                className="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
            ></span>
            Searching...
        </button>
    );
};

const DisabledButton = () => {
    return (
        <button className="btn btn-secondary" type="button" disabled={true}>
            Choose an Attorney...
        </button>
    );
};

const CaseExportExecuteResponse = ({
    attorneyName,
    response,
    ran,
    loading,
}: {
    attorneyName: string;
    response: GuidDetailedResponse;
    ran: boolean;
    loading: boolean;
}): JSX.Element => {
    if (ran && !loading) {
        if (response.successful && response.data) {
            return (
                <div className="row mt-4">
                    <div className="col-md-12">
                        <div className="alert alert-success" role="alert">
                            Case Export Successfully Started for&nbsp;
                            {attorneyName}&nbsp; with the ID:&nbsp;
                            {response.data}
                        </div>
                    </div>
                </div>
            );
        } else {
            if (response.errorMessage) {
                return (
                    <div className="row mt-4">
                        <div className="col-md-12">
                            <div className="alert alert-danger" role="alert">
                                {response.errorMessage}
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="row mt-4">
                        <div className="col-md-12">
                            <div className="alert alert-warning" role="alert">
                                Something happened, and this was not planned.
                                Try Again later.
                            </div>
                        </div>
                    </div>
                );
            }
        }
    } else {
        return <></>;
    }
};
